import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TmcYardCommonModule } from '../../../common/common.module';
import { TransportSelectionComponent } from './component/transport-selection.component';
import { CommonLayoutModule } from '@sdbn/common';

@NgModule({
  declarations: [
    TransportSelectionComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    CommonLayoutModule,
    CommonUIModule
  ],
  exports: [
    TransportSelectionComponent
  ]
})
export class TransportSelectionModule { }
